import { Register } from "../components/holdings-project-register/Register";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
ホールディングス案件登録
 */
const HoldingsRegister = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.HD);
  return (
    <SpaceBetween size="l">
      <Register />
    </SpaceBetween>
  );
};

export default HoldingsRegister;
